import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const useSmoothScroll = () => {
  const location = useLocation()

  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const anchor = target.closest('a')

      if (!anchor) return

      const href = anchor.getAttribute('href')
      if (!href) return

      // Check if it's an anchor link (starts with # or /#)
      const isAnchorLink = href.startsWith('#') || href.startsWith('/#')

      if (isAnchorLink) {
        // Extract the section ID
        const sectionId = href.replace(/^\/#?/, '')
        const section = document.getElementById(sectionId)

        // Only prevent default and smooth scroll if we're on the home page
        // and the section exists
        if (location.pathname === '/' && section) {
          e.preventDefault()

          // Calculate offset for fixed header (header height + announcement banner + some padding)
          const headerOffset = 120 // Adjust this value based on your header height
          const elementPosition = section.getBoundingClientRect().top
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })

          // Update URL without jumping
          window.history.pushState({}, '', `/#${sectionId}`)
        }
        // If we're not on the home page, let the link navigate normally
        // (it will go to /#section)
      }
    }

    document.addEventListener('click', handleAnchorClick)

    return () => {
      document.removeEventListener('click', handleAnchorClick)
    }
  }, [location.pathname])

  // Scroll to section on page load if hash is present
  useEffect(() => {
    if (location.hash && location.pathname === '/') {
      const sectionId = location.hash.replace('#', '')
      const section = document.getElementById(sectionId)

      if (section) {
        // Wait a bit for the page to render
        setTimeout(() => {
          const headerOffset = 120
          const elementPosition = section.getBoundingClientRect().top
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })
        }, 100)
      }
    }
  }, [location])
}
